"use strict";
/*
 * Frecency
 *
 * Inspired by: https://wiki.mozilla.org/User:Jesse/NewFrecency
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVisit = exports.visit = exports.init = exports.decayFor = exports.decayRate = void 0;
// natural log2
const ln2 = 0.69314718055994530942; // Math.log1p(2)
exports.decayRate = (hl) => {
    return ln2 / hl;
};
exports.decayFor = (t, hl) => {
    return t * exports.decayRate(hl);
};
exports.init = (now, hl) => {
    return {
        hl,
        score: exports.decayFor(now, hl),
    };
};
exports.visit = (now, prev) => {
    const decay = exports.decayFor(now, prev.hl);
    return {
        ...prev,
        score: Math.log1p(Math.exp(prev.score - decay)) + decay,
    };
};
const now = () => (new Date()).getTime();
exports.createVisit = (hl, nowfn = now) => {
    return (prev) => {
        if (prev) {
            return exports.visit(nowfn(), prev);
        }
        return exports.init(nowfn(), hl);
    };
};
exports.default = exports.createVisit;
//# sourceMappingURL=index.js.map